import React from 'react'

interface Props {
  replies: Array<{ label: string; action: string; primary?: boolean }>
  onReply: (action: string, label: string) => void
}

export const QuickReplies: React.FC<Props> = ({ replies, onReply }) => (
  <div className="aiClerk-att-quick">
    {replies.map((r, i) => (
      <button
        key={i}
        type="button"
        className={`aiClerk-att-quick__btn ${
          r.primary ? 'aiClerk-att-quick__btn--primary' : ''
        }`}
        onClick={() => onReply(r.action, r.label)}
      >
        {r.label}
      </button>
    ))}
  </div>
)
